import getScenarioStore from '../selectors/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { mutator } from 'satcheljs';
import { removeSuggestionPillFromStore } from '../actions/internalActions';

export default mutator(removeSuggestionPillFromStore, actionMessage => {
    const { suggestionPillId, suggestionPillIndex, scenarioId } = actionMessage;
    const store = getScenarioStore(scenarioId);

    // Remove all traces of suggestion pill from store.
    store.suggestionPills.delete(suggestionPillId);
    store.suggestionPillIds.splice(suggestionPillIndex, 1);

    // Reset selected pill index.
    store.selectedPillIndex = createDefaultSearchStore().selectedPillIndex;
});
